/*
 * Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/* GLOBALS */
export var AnimationStatus;
(function (AnimationStatus) {
    AnimationStatus["ready"] = "ready";
    AnimationStatus["active"] = "active";
    AnimationStatus["start"] = "starting";
    AnimationStatus["end"] = "done";
})(AnimationStatus || (AnimationStatus = {}));
export const CLARITY_MOTION_ENTER_LEAVE_PROPERTY = 'hidden';
export const CLARITY_MOTION_REVERSE_ANIMATION_LABEL = 'reverse';
export const CLARITY_MOTION_REVERSE_ANIMATION_SUFFIX = '-' + CLARITY_MOTION_REVERSE_ANIMATION_LABEL;
export const CLARITY_MOTION_FALLBACK_DURATION_IN_MS = 300;
export const CLARITY_MOTION_FALLBACK_EASING = 'linear';
export const PRIVATE_ANIMATION_STATUS_ATTR_NAME = '_cds-animation-status';
